import { TRACKING_OPERATION, TRACKING_PAGE } from './tracking/constants';
import reporter, { reportPageName } from './report';

enum ErrorType {
  ErrorEvent,
  PromiseRejectionEvent,
  Error,
}

// 这里只统计次数, 内容后续通过 sentry 观察
// TODO from sentry: Can't find variable: PromiseRejectionEvent
export function onErrorCount(ev: ErrorEvent | PromiseRejectionEvent | Error) {
  if (!ev) {
    return;
  }

  let error = new Error('onError caught');
  let type: ErrorType = ErrorType.ErrorEvent;

  switch (true) {
    case ev instanceof Error:
      error = ev as Error;
      type = ErrorType.Error;
      break;
    case !!(ev as PromiseRejectionEvent).reason:
      error = (ev as PromiseRejectionEvent).reason;
      type = ErrorType.PromiseRejectionEvent;
      break;
    case ev instanceof ErrorEvent:
      if ((ev as ErrorEvent).target instanceof HTMLScriptElement) {
        // err.target 为 HTMLScriptElement 一般没有 message
        return;
      }
      error = (ev as ErrorEvent).error;
      break;
  }

  // error可能为null
  const message = error?.message || error?.toString();

  // 过滤掉非chatbot错误上报统计
  const isFromChatbot = chatbotSourceReg.test((ev as ErrorEvent)?.filename ?? error.stack);
  // 过滤不需要上报的错误，如正常报错来停止程序继续执行，但没有catch的情况
  const needFilterReport = blacklistReg.some((w) => w.test(message));
  if (isFromChatbot && !needFilterReport) {
    reporter.apiBatchReport({ type: 'count', value: { label: 'chatbot_js_error_total' }});
  }

  reporter.apiBatchReport({ type: 'count', value: { label: 'js_error_total' }});
  reporter.apiLog(message);
  reporter.biReport({
    page_type: TRACKING_PAGE.GAME_HIPO_TRACK,
    operation: TRACKING_OPERATION.ACTION_HIPO,
    data: {
      page_name: reportPageName,
      hipo_type: 'action_js_error',
    },
  });
}

const chatbotSourceReg = new RegExp(`shopee\-chatbot\-(test|uat|staging|live)\-[a-z]{2,}\\/|${location.origin}`);
const blacklistReg: RegExp[] = [
  /web Unsupported CMD/,
  /Network Error/i,
  /timeout of \d+ms exceeded/,
  /Loading chunk \d+ failed after \d retries/,
  /Failed to register a ServiceWorker for scope/,
];

window.addEventListener('error', onErrorCount);
window.addEventListener('unhandledrejection', onErrorCount);
